/*** IMPORTS FROM imports-loader ***/
var define = false;

jQuery(document).ready(function($) {

    //$('.autoplay').slick('slickSetOption', 'autoplay', true, true);

});

